import { createContext, useReducer } from 'react';

import userReducer, { INITIAL_STATE } from './userReducer';

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
    const [state, dispatch] = useReducer(userReducer, { ...INITIAL_STATE });

    return (
        <UserContext.Provider
            value={{
                dispatch,
                state
            }}>
            {children}
        </UserContext.Provider>
    );
};
